import { InstallationModeContext } from "contexts/InstallationMode/installation-mode-context";
import { useContext } from "react";

const useInstallationMode = () => useContext(InstallationModeContext);
export default useInstallationMode;
